/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Generated by orval v7.6.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  GetProductDetailPriceByIdServerParams,
  GetProductPriceParams,
  GetProductPriceServerParams,
  PdpProductPriceDTO,
  PriceDTO,
  PriceSkuInfo,
} from '@as-react/common-types/price-service';
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import { queryFetch } from '../../utils/orval/queryFetch';
import type { ErrorType } from '../../utils/orval/queryFetch';
import { queryKeyMutator } from '../../utils/orval/queryKeyMutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getProductPrice = (
  productId: number,
  mainWebShop: string,
  webShopId: number,
  params: GetProductPriceParams,
  operationName = 'getProductPrice',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<PriceDTO>(
    { url: `/api/aem/product/price/${productId}/${mainWebShop}/${webShopId}`, method: 'GET', params, signal },
    { operationName: 'getProductPrice', ...options }
  );
};

export const useGetProductPriceQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductPrice>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  mainWebShop: string,
  webShopId: number,
  params: GetProductPriceParams,
  operationName = 'getProductPrice',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductPrice>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { productId, mainWebShop, webShopId, params, operationName },
    { url: `/api/aem/product/price/${productId}/${mainWebShop}/${webShopId}`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductPrice>>> = ({ signal }) =>
    getProductPrice(productId, mainWebShop, webShopId, params, operationName, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(productId && mainWebShop && webShopId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductPrice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductPriceQueryResult = NonNullable<Awaited<ReturnType<typeof getProductPrice>>>;
export type GetProductPriceQueryError = ErrorType<unknown>;

export function useGetProductPrice<TData = Awaited<ReturnType<typeof getProductPrice>>, TError = ErrorType<unknown>>(
  productId: number,
  mainWebShop: string,
  webShopId: number,
  params: GetProductPriceParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductPrice>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductPrice>>,
          TError,
          Awaited<ReturnType<typeof getProductPrice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductPrice<TData = Awaited<ReturnType<typeof getProductPrice>>, TError = ErrorType<unknown>>(
  productId: number,
  mainWebShop: string,
  webShopId: number,
  params: GetProductPriceParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductPrice>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductPrice>>,
          TError,
          Awaited<ReturnType<typeof getProductPrice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductPrice<TData = Awaited<ReturnType<typeof getProductPrice>>, TError = ErrorType<unknown>>(
  productId: number,
  mainWebShop: string,
  webShopId: number,
  params: GetProductPriceParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductPrice>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProductPrice<TData = Awaited<ReturnType<typeof getProductPrice>>, TError = ErrorType<unknown>>(
  productId: number,
  mainWebShop: string,
  webShopId: number,
  params: GetProductPriceParams,
  operationName = 'getProductPrice',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductPrice>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetProductPriceQueryOptions(
    productId,
    mainWebShop,
    webShopId,
    params,
    operationName,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getProductPriceServer = (
  productId: number,
  mainWebShop: string,
  webShopId: number,
  params: GetProductPriceServerParams,
  operationName = 'getProductPrice',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<PriceDTO>(
    { url: `/public/price/${productId}/${mainWebShop}/${webShopId}`, method: 'GET', params, signal },
    { operationName: 'getProductPrice', service: 'price-service', ...options }
  );
};

export const useGetProductPriceServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductPriceServer>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  mainWebShop: string,
  webShopId: number,
  params: GetProductPriceServerParams,
  operationName = 'getProductPrice',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductPriceServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { productId, mainWebShop, webShopId, params, operationName },
    { url: `/public/price/${productId}/${mainWebShop}/${webShopId}`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductPriceServer>>> = ({ signal }) =>
    getProductPriceServer(productId, mainWebShop, webShopId, params, operationName, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(productId && mainWebShop && webShopId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductPriceServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductPriceServerQueryResult = NonNullable<Awaited<ReturnType<typeof getProductPriceServer>>>;
export type GetProductPriceServerQueryError = ErrorType<unknown>;

export function useGetProductPriceServer<
  TData = Awaited<ReturnType<typeof getProductPriceServer>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  mainWebShop: string,
  webShopId: number,
  params: GetProductPriceServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductPriceServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductPriceServer>>,
          TError,
          Awaited<ReturnType<typeof getProductPriceServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductPriceServer<
  TData = Awaited<ReturnType<typeof getProductPriceServer>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  mainWebShop: string,
  webShopId: number,
  params: GetProductPriceServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductPriceServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductPriceServer>>,
          TError,
          Awaited<ReturnType<typeof getProductPriceServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductPriceServer<
  TData = Awaited<ReturnType<typeof getProductPriceServer>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  mainWebShop: string,
  webShopId: number,
  params: GetProductPriceServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductPriceServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProductPriceServer<
  TData = Awaited<ReturnType<typeof getProductPriceServer>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  mainWebShop: string,
  webShopId: number,
  params: GetProductPriceServerParams,
  operationName = 'getProductPrice',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductPriceServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetProductPriceServerQueryOptions(
    productId,
    mainWebShop,
    webShopId,
    params,
    operationName,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const findSkuInfo = (
  market: string,
  mainWebShopId: number,
  webShopId: number,
  productId: number,
  skuId: number,
  operationName = 'findSkuInfo',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<PriceSkuInfo>(
    {
      url: `/api/aem/product/price/sku/${market}/${mainWebShopId}/${webShopId}/${productId}/${skuId}`,
      method: 'GET',
      signal,
    },
    { operationName: 'findSkuInfo', ...options }
  );
};

export const useFindSkuInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof findSkuInfo>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  webShopId: number,
  productId: number,
  skuId: number,
  operationName = 'findSkuInfo',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSkuInfo>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { market, mainWebShopId, webShopId, productId, skuId, operationName },
    { url: `/api/aem/product/price/sku/${market}/${mainWebShopId}/${webShopId}/${productId}/${skuId}`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSkuInfo>>> = ({ signal }) =>
    findSkuInfo(market, mainWebShopId, webShopId, productId, skuId, operationName, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(market && mainWebShopId && webShopId && productId && skuId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof findSkuInfo>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type FindSkuInfoQueryResult = NonNullable<Awaited<ReturnType<typeof findSkuInfo>>>;
export type FindSkuInfoQueryError = ErrorType<unknown>;

export function useFindSkuInfo<TData = Awaited<ReturnType<typeof findSkuInfo>>, TError = ErrorType<unknown>>(
  market: string,
  mainWebShopId: number,
  webShopId: number,
  productId: number,
  skuId: number,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSkuInfo>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSkuInfo>>,
          TError,
          Awaited<ReturnType<typeof findSkuInfo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSkuInfo<TData = Awaited<ReturnType<typeof findSkuInfo>>, TError = ErrorType<unknown>>(
  market: string,
  mainWebShopId: number,
  webShopId: number,
  productId: number,
  skuId: number,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSkuInfo>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSkuInfo>>,
          TError,
          Awaited<ReturnType<typeof findSkuInfo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSkuInfo<TData = Awaited<ReturnType<typeof findSkuInfo>>, TError = ErrorType<unknown>>(
  market: string,
  mainWebShopId: number,
  webShopId: number,
  productId: number,
  skuId: number,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSkuInfo>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useFindSkuInfo<TData = Awaited<ReturnType<typeof findSkuInfo>>, TError = ErrorType<unknown>>(
  market: string,
  mainWebShopId: number,
  webShopId: number,
  productId: number,
  skuId: number,
  operationName = 'findSkuInfo',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSkuInfo>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useFindSkuInfoQueryOptions(
    market,
    mainWebShopId,
    webShopId,
    productId,
    skuId,
    operationName,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const findSkuInfoServer = (
  market: string,
  mainWebShopId: number,
  webShopId: number,
  productId: number,
  skuId: number,
  operationName = 'findSkuInfo',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<PriceSkuInfo>(
    { url: `/public/price/sku/${market}/${mainWebShopId}/${webShopId}/${productId}/${skuId}`, method: 'GET', signal },
    { operationName: 'findSkuInfo', service: 'price-service', ...options }
  );
};

export const useFindSkuInfoServerQueryOptions = <
  TData = Awaited<ReturnType<typeof findSkuInfoServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  webShopId: number,
  productId: number,
  skuId: number,
  operationName = 'findSkuInfo',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSkuInfoServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { market, mainWebShopId, webShopId, productId, skuId, operationName },
    { url: `/public/price/sku/${market}/${mainWebShopId}/${webShopId}/${productId}/${skuId}`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSkuInfoServer>>> = ({ signal }) =>
    findSkuInfoServer(market, mainWebShopId, webShopId, productId, skuId, operationName, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(market && mainWebShopId && webShopId && productId && skuId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof findSkuInfoServer>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type FindSkuInfoServerQueryResult = NonNullable<Awaited<ReturnType<typeof findSkuInfoServer>>>;
export type FindSkuInfoServerQueryError = ErrorType<unknown>;

export function useFindSkuInfoServer<
  TData = Awaited<ReturnType<typeof findSkuInfoServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  webShopId: number,
  productId: number,
  skuId: number,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSkuInfoServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSkuInfoServer>>,
          TError,
          Awaited<ReturnType<typeof findSkuInfoServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSkuInfoServer<
  TData = Awaited<ReturnType<typeof findSkuInfoServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  webShopId: number,
  productId: number,
  skuId: number,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSkuInfoServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSkuInfoServer>>,
          TError,
          Awaited<ReturnType<typeof findSkuInfoServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSkuInfoServer<
  TData = Awaited<ReturnType<typeof findSkuInfoServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  webShopId: number,
  productId: number,
  skuId: number,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSkuInfoServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useFindSkuInfoServer<
  TData = Awaited<ReturnType<typeof findSkuInfoServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  webShopId: number,
  productId: number,
  skuId: number,
  operationName = 'findSkuInfo',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSkuInfoServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useFindSkuInfoServerQueryOptions(
    market,
    mainWebShopId,
    webShopId,
    productId,
    skuId,
    operationName,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getProductDetailPriceByIdServer = (
  productId: number,
  mainWebShop: string,
  webShopId: number,
  params: GetProductDetailPriceByIdServerParams,
  operationName = 'getProductDetailPriceById',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<PdpProductPriceDTO>(
    { url: `/pdp/${productId}/${mainWebShop}/${webShopId}`, method: 'GET', params, signal },
    { operationName: 'getProductDetailPriceById', service: 'price-service', ...options }
  );
};

export const useGetProductDetailPriceByIdServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductDetailPriceByIdServer>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  mainWebShop: string,
  webShopId: number,
  params: GetProductDetailPriceByIdServerParams,
  operationName = 'getProductDetailPriceById',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductDetailPriceByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { productId, mainWebShop, webShopId, params, operationName },
    { url: `/pdp/${productId}/${mainWebShop}/${webShopId}`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductDetailPriceByIdServer>>> = ({ signal }) =>
    getProductDetailPriceByIdServer(productId, mainWebShop, webShopId, params, operationName, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(productId && mainWebShop && webShopId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductDetailPriceByIdServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductDetailPriceByIdServerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductDetailPriceByIdServer>>
>;
export type GetProductDetailPriceByIdServerQueryError = ErrorType<unknown>;

export function useGetProductDetailPriceByIdServer<
  TData = Awaited<ReturnType<typeof getProductDetailPriceByIdServer>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  mainWebShop: string,
  webShopId: number,
  params: GetProductDetailPriceByIdServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductDetailPriceByIdServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductDetailPriceByIdServer>>,
          TError,
          Awaited<ReturnType<typeof getProductDetailPriceByIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductDetailPriceByIdServer<
  TData = Awaited<ReturnType<typeof getProductDetailPriceByIdServer>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  mainWebShop: string,
  webShopId: number,
  params: GetProductDetailPriceByIdServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductDetailPriceByIdServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductDetailPriceByIdServer>>,
          TError,
          Awaited<ReturnType<typeof getProductDetailPriceByIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductDetailPriceByIdServer<
  TData = Awaited<ReturnType<typeof getProductDetailPriceByIdServer>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  mainWebShop: string,
  webShopId: number,
  params: GetProductDetailPriceByIdServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductDetailPriceByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProductDetailPriceByIdServer<
  TData = Awaited<ReturnType<typeof getProductDetailPriceByIdServer>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  mainWebShop: string,
  webShopId: number,
  params: GetProductDetailPriceByIdServerParams,
  operationName = 'getProductDetailPriceById',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductDetailPriceByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetProductDetailPriceByIdServerQueryOptions(
    productId,
    mainWebShop,
    webShopId,
    params,
    operationName,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
